<script setup lang="ts">
import { computed } from "vue";
import { useConditionStore } from "../condition/conditions.store";
import { useSettingsStore } from "@editor/store/settings.store";

import ConditionLabel from "../condition/ConditionLabel.vue";

import type { IncidentTriggerItem } from "./IncidentTriggerItem";

const props = defineProps<{
  trigger: IncidentTriggerItem;
  index?: number;
}>();

const conditionStore = useConditionStore();
const settingsStore = useSettingsStore();

const conditions = computed(() => {
  return conditionStore.byTrigger[props.trigger.id] || [];
});

const roundUnit = computed(() => settingsStore.simulationRoundUnit);
</script>

<template>
  <div>
    <div class="trigger-title__heading" v-if="index != null">
      {{ $t("objectNames.trigger") }} {{ index + 1 }}
    </div>
    <span v-if="trigger.title">{{ trigger.title }}</span>
    <span v-else>
      <span v-if="trigger.chance < 100"> {{ trigger.chance }}%</span>
      <span v-if="trigger.chance < 100 && conditions.length > 0">, </span>
      <span v-if="conditions.length == 1">
        <condition-label :condition-id="conditions[0].id" />
      </span>
      <span v-else-if="conditions.length > 1">
        {{ conditions.length }}
        {{ $t("objectNames.condition", conditions.length) }}
      </span>
      <span v-else-if="trigger.chance == 100">
        {{ $t(`timeEvery.${roundUnit}`) }}
      </span>
    </span>
  </div>
</template>

<style>
.trigger-title__heading {
  font-size: 12px;
  font-weight: bold;
  color: var(--color-text-medium);
  margin-bottom: 0.25rem;
}
</style>
